/*
  Element-level fade-in animations.
  Standard elements: fade up individually via IntersectionObserver.
  Cards: .stagger-cards container gets .cards-visible when in viewport,
  CSS nth-child animation-delay handles the 1-at-a-time stagger.
*/
(function() {
  var SELECTOR = [
    '.section-header',
    '.hero__title',
    '.subheading',
    '.rte',
    '.btn-group',
    '.blocks-button',
    'figure',
    '.image-with-text__media',
    '.image-with-text__content',
    '.before-after__slider',
    '.count-down',
    '.media-wrapper',
    '.product-media-slider',
    '.hotspot-image-wrapper',
    '.hotspot-image',
    '.richtext-section__container',
    'img.standalone-image'
  ].join(',');

  var SKIP_CLASSES = [
    'section-wave-divider',
    'section-divider',
    'section-sliding-text'
  ];

  function shouldSkip(section) {
    for (var i = 0; i < SKIP_CLASSES.length; i++) {
      if (section.classList.contains(SKIP_CLASSES[i])) return true;
    }
    return false;
  }

  function initElementAnimations() {
    if (Shopify && Shopify.designMode) return;

    // Observer for standard elements
    var elObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('anim-el-in');
          elObserver.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px -40px 0px',
      threshold: 0.01
    });

    // Observer for card containers
    var cardObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cards-visible');
          cardObserver.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px -40px 0px',
      threshold: 0.01
    });

    var sections = document.querySelectorAll('main .shopify-section');

    sections.forEach(function(section) {
      if (shouldSkip(section)) return;

      // Standard elements
      var els = section.querySelectorAll(SELECTOR);
      var delay = 0;

      els.forEach(function(el) {
        if (el.closest('.gridy-slider') || el.closest('product-recommendations')) return;
        if (el.hasAttribute('data-anim-el')) return;
        if (el.closest('[data-anim-el]')) return;

        el.setAttribute('data-anim-el', '');
        if (delay > 0 && delay <= 8) {
          el.setAttribute('data-anim-delay', delay);
        }
        delay++;
        elObserver.observe(el);
      });

      // Card containers
      var staggerEls = section.querySelectorAll('.stagger-cards');
      staggerEls.forEach(function(el) {
        cardObserver.observe(el);
      });
    });

    // Watch for dynamically loaded product recommendations
    var recEls = document.querySelectorAll('product-recommendations');
    recEls.forEach(function(rec) {
      var mo = new MutationObserver(function() {
        var grid = rec.querySelector('.stagger-cards');
        if (grid) {
          cardObserver.observe(grid);
          mo.disconnect();
        }
      });
      mo.observe(rec, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initElementAnimations);
  } else {
    initElementAnimations();
  }
})();
